var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-20 flex justify-center items-center text-sm"},[(_vm.isMobile)?_c('router-link',{staticClass:"no-underline",attrs:{"to":"/privacy"}},[_vm._v("Privacy")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }